import { dispatcher, IEvent, ingenuity, toInt } from "@quest/base-core";
import { AudioControllerBehavior, ReelPanelController, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
/**
 * ReelPanelControllerGame class hanles the slot reel functionality for the base game.
 */
export class ReelPanelControllerGame extends ReelPanelController {
  private cascadeOnReelsCounter: number = 0;

  /**
   * subscribe all events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.CASCADE_SPIN_COMPLETE, this.onCascadeSpinComplete, this);
    dispatcher.on(eventDispatchers.UPDATE_STATIC_GRID, this.onUpdateStaticGrid, this);
  }

  /**
   * unsubscribe all events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.CASCADE_SPIN_COMPLETE, this.onCascadeSpinComplete, this);
    dispatcher.off(eventDispatchers.UPDATE_STATIC_GRID, this.onUpdateStaticGrid, this);
  }
  /**
   * function will update the grid on reelpanel
   */
  private onUpdateStaticGrid(evt: IEvent): void {
    evt.data && (ingenuity.parserModel as GameParserModel).setReelGrid(evt.data);
    this.view.getReelView().showStaticGrid((ingenuity.parserModel as GameParserModel).getReelGrid());
  }

  /**
   * This method is use to show win after cascading is completed
   */
  private onCascadeSpinComplete(): void {
    this.cascadeOnReelsCounter += 1;
    if (this.cascadeOnReelsCounter === (ingenuity.parserModel as GameParserModel).getCurrentCascadingReelNumber()) {
      this.cascadeOnReelsCounter = 0;
      const currenCascadeCount: number = (ingenuity.parserModel as GameParserModel).getCascadingCount();
      (ingenuity.parserModel as GameParserModel).setCascadingCount(currenCascadeCount - 1);
      if ((ingenuity.parserModel as GameParserModel).getCascadeWin()) {
        dispatcher.fireEvent(eventDispatchers.RESET_CASCADE_COUNTER);
        dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);

      } else {
        dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
      }
    }
  }

  // function override to unfade of all reels during anticipation on last reel stopping
  protected handleFadeAndUnfadeAnticipation(evt: IEvent) {
    const isAnticipationPresent =
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] &&
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] === 1 &&
      !ingenuity.configData.spinStopPressed;
    if (isAnticipationPresent && ingenuity.configData.fadeReelOnAnticipation) {
      this.fadeSymbolOnAnticipation(toInt(evt.toString()));
      ingenuity.configData.currentAnticipation = toInt(evt.toString()) + 1;
    }
    // to unfade all reels on last reel stopping
    if (
      toInt(evt.toString()) === this.reelView.getModel().numReels - 1 &&
      ingenuity.configData.fadeReelOnAnticipation
    ) {
      this.unFadeSymbolAfterAnticipation();
    }
  }
  /**
   * to fade symbols on anticipation instead of triggering symbol
   */
  protected fadeSymbolOnAnticipation(reel: any) {
    let numOfReel = reel;
    for (let i = 0; i <= numOfReel; i++) {
      this.reelView.children[i].forEach((sym: any, index: number) => {
        if ((sym.num !== gameConstants.RESPIN_TRIGGER_SYM)) {
          sym.tint = SlotConstantsBehavior.FADED_SYMBOL;
        }
      });
    }
  }
  // Overrided to destroy the current cascde spine data on nextspin
  protected onSpinReel(evt: IEvent): void {
    super.onSpinReel(evt);
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_BASEGAME);
    dispatcher.fireEvent(eventDispatchers.BURST_SYMBOLS_DESTROY);
  }
  /**
   * overrided to remove check for win after reel  stop flow and add CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION
   */
  protected onSpinComplete(evt?: IEvent): void {
    (ingenuity.parserModel as GameParserModel).setIsSpinClicked(false);
    ingenuity.configData.spinComplete = true;
    this.reelView.getModel().quickSpin = false;
    this.reelView.setStopNow(false);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
    dispatcher.fireEvent(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION);
    if ((ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    }
    dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
  }
  protected handleAnticipationSound(eventIndex: any) {
    const value = (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()[0][eventIndex];
    if (value === undefined && !ingenuity.configData.isPlayAnticipationSound && !this.model.getIsTurboModeOn()) {
      (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.REEL_STOP, 0.8, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
    if (this.model.getIsTurboModeOn() && (eventIndex === 0)) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.REEL_STOP, vol: 0.8, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
    }
    if (ingenuity.configData.isPlayAnticipationSound) {
      // Play anticipation reel stop sound
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.ANTICIPATION_REEL_STOP, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
    }
  }
  protected onReelStopped(evt: any) {
    if (toInt(evt.toString()) === this.reelView.getModel().numReels - 1) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.ANTICIPATION_SOUND, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
    }
  }
}
